var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VStatus',{attrs:{"text":_vm.text,"variant":_vm.variant,"options":_vm.options,"disabled":_vm.disabled},on:{"input":function($event){return _vm.$emit('input', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }